export default "__VITE_ASSET__BY7_6wxx__"